export const language: any = {
  OkLogout: "はい",
  CloseLogout: "いいえ",
  OkLeave: "退会",
  CloseLeave: "キャンセル",
  LabelPolicy: "プライバシーポリシー",
  AppName: "Hey! Cooker",
  OnOffNotification: "通知のオン/オフ",
  LabelReceiveNotificationSuggestion: "レシピ提案の通知を受け取る",
  LabelReceiveNotifyBreakfast: "毎日の朝食のおすすめを受け取る",
  LabelReceiveNotifyLunch: "毎日の昼食のおすすめを受け取る",
  LabelReceiveNotifyDinner: "毎日の夕食のおすすめを受け取る",
  notification_history: "通知履歴",
  readAll: "すべて読む",
  no_notification: "通知履歴はありません",
  labelDisplayName: "表示名を入力",
  placeholderDisplayName: "最低4文字、最大20文字を入力してください",
  changeDisplayName: "表示名を変更",
};
